import { init, event, identify } from 'trackhome'

const ENDPOINT = 'https://go.winit.ai'

function envTag() {
  if (process.env.WINIT_ENV === 'production') return 'env:prod'
  if (process.env.WINIT_ENV === 'staging') return 'env:stag'
  return 'env:dev'
}

function isEnabled() {
  return (
    typeof window !== 'undefined' &&
    process.env.WINIT_ENV !== 'test' &&
    process.env.WINIT_ENV !== 'development'
  )
}

export function initTrackhome() {
  if (!isEnabled()) return
  init({
    endpoint: ENDPOINT,
    tags: ['app:webapp', envTag()],
    autoPageView: false,
  })
}

export function trackEvent(name, tags = [], value) {
  if (!isEnabled()) return
  event(name, tags, value)
}

export function identifyUser(userId) {
  if (!isEnabled()) return
  identify(userId)
}
